var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-20 p-5 text-center position-relative"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.$publicPath + 'img/video-placeholder.png'}}),_c('span',{staticClass:"video-info position-absolute"},[_c('img',{attrs:{"src":_vm.$publicPath + 'img/soon.svg'}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }